import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Spinner from '../../common/Spinner';

import './LoadingPage.scss';

export default function LoadingPage({ hideLink, invertColors, title }) {
  return (
    <div>
      { title }

      <Header hideLink={hideLink} invertedColors={invertColors} />

      <div styleName="spinner_container">
        <Spinner styleName="spinner" />
      </div>
    </div>
  );
}

LoadingPage.propTypes = {
  hideLink: PropTypes.bool,
  invertColors: PropTypes.bool,
  title: PropTypes.node
};

LoadingPage.defaultProps = {
  hideLink: false,
  invertColors: false,
  title: null
};
